
import axiosClient from "../../../api/axiosClient";

const BASE_URL = "/api/trading/costings";

const tradingCostingService = {
  // List costings; optionally filter by Trading Enquiry.
  getCostings(params = {}) {
    return axiosClient.get(BASE_URL, { params });
  },

  // Retrieve one costing with its items.
  getCosting(costingId) {
    return axiosClient.get(`${BASE_URL}/${costingId}`);
  },

  // Create a costing for a Trading Enquiry.
  createCosting(payload) {
    return axiosClient.post(BASE_URL, payload);
  },

  
updateCosting(costingId, payload) {
  return axiosClient.put(`${BASE_URL}/${costingId}`, payload);
},

approveCosting(costingId) {
  return axiosClient.post(`${BASE_URL}/${costingId}/approve`);
},

};

export default tradingCostingService;
